import React from "react";
import { useTranslation } from "react-i18next";

import { useHistory } from "react-router-dom";
import axios from "axios";
import { displayDateByLanguage } from "../../Utils/utils";

import "./Sheets.css";


function Sheets(props, userData) {
  const { t } = useTranslation();
  const { sheets } = props;
  const userLang = userData?.language || 'de';

  let history = useHistory();

  // Falls das Array noch lädt oder leer ist, sichern wir das Mapping ab
  if (!sheets || sheets.length === 0) {
    return <ul className="all-sheets-container"><li>{t("PageSheets.no_sheets_found")}</li></ul>;
  }

  const sheetItems = sheets.map((sheet, index) => {
    // ⭐ FIX 1: Ein mathematisch eindeutiger Key! 
    // Wir nutzen primär die ID aus der SQLite-Datenbank. 
    // Falls diese fehlt, nutzen wir die Kombination aus Index und Name, um Duplikate zu verhindern.
    const uniqueKey = sheet.id || sheet._id || `sheet-${index}-${sheet.sheetName}`;

    return (
      <li
        key={uniqueKey} // Jetzt absolut crash-sicher!
        onClick={() => {
          // Sicherstellen, dass pdfUrl existiert, bevor wir split() aufrufen
          if (sheet.pdfUrl) {
            history.push(`sheet/${sheet.pdfUrl.split("pdf/").pop()}`);
          } else if (sheet.safeSheetName) {
            // Sicherer Fallback, falls pdfUrl mal nicht gefüllt ist
            history.push(`sheet/${sheet.safeSheetName}`);
          }
        }}
      >
        <div className="box-container remove_shadow">
          <img
            className="thumbnail-image"
            src={`${axios.defaults.baseURL}/sheet/thumbnail/${sheet.safeSheetName}`}
            alt={`${t("common.sheet")} ${t("files.thumbnail")}`}
          />
          <div className="sheet-name-container">
			<span className="sheet-name">{sheet.sheetName}</span>
          </div>
        <div className="sheet-composer-container">
          <span className="sheet-composer"><br/><span className="text-highlight">{sheet.composer}<br/></span>
          {t("sheet.releaseDate")}: <br/><span className="text-highlight">{displayDateByLanguage(sheet.releaseDate, userLang)} <br/></span>
          </span>
        </div>
        </div>
      </li>
    );
  });

  return <ul className="all-sheets-container">{sheetItems}</ul>;
}

export default Sheets;